// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"yL","iconEffect":"yM","ripple":"yN","a":"yO"};